import Login from "./Login";
import { Footer } from "../components";

const Home = () => {
  return (
    <div>
      <Login />
      <Footer />
    </div>
  );
};

export default Home;
